import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=e5237888&"
import script from "./input-textarea.vue?vue&type=script&lang=js&"
export * from "./input-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports